var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    attrs: {
      "value": _vm.ONLINE.value
    }
  }, [_c('div', {
    staticClass: "page-section-wrap"
  }, [_c('section', {
    staticClass: "page-section"
  }, [_c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("온라인 경매")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "9"
    }
  }, [_c('div', [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("경매 참여")])]), _c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("'응찰' 혹은 '예약응찰' 버튼을 클릭해 응찰 페이지로 이동하여 경매에 참여할 수 있습니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("원하시는 작품의 현재가를 확인 후 최고 응찰가를 선택하여 응찰할 수 있습니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("실시간으로 응찰하거나 미리 최고 응찰가를 입력해두시면 해당 작품의 다른 응찰에 대응하여 사전에 입력한 최고 응찰가까지 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("자동으로 응찰이 이뤄집니다.")])])])]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("마감 시간")])]), _c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("프리뷰 전시 기간 동안 홈페이지를 통해 응찰 가능하며, 경매 마감 시간부터 lot 번호 순차적으로 마감됩니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("각 작품마다 마감시간이 다르며, LOT순 1분 간격 1점씩 마감됩니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("작품 마감 30초 전에 응찰이 들어왔을 경우, 해당작품 마감이 30초 연장됩니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("온라인 경매 회차에 따라 위 마감 시간이 다를 수 있습니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("한번 응찰된 작품은 응찰을 취소 할 수 없습니다. 신중한 선택 부탁 드립니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("경매 마감 시간부터 5분 간격으로 10점씩 마감되며, 경매 마감 시간 30초 전에 새로운 응찰이 있을 경우 마감시간이 자동으로 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("30초 연장됩니다.")])])])]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("수동응찰 · 자동응찰")])]), _c('div', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    staticClass: "h-100",
    attrs: {
      "tile": "",
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "pa-16 px-md-30 py-md-20"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "width": "40",
      "height": "40",
      "src": "/images/sub/how-to/how-to-bid-online-icon.png"
    }
  })], 1), _c('v-col', [_c('div', {
    staticClass: "page-text"
  }, [_c('p', {
    staticClass: "primary--text"
  }, [_vm._v("1회응찰 / Bid")]), _c('p', [_vm._v("주어진 금액에 따라 1회씩 수동응찰")])])])], 1)], 1)])], 1), _c('v-col', {
    staticClass: "mt-n1 mt-md-0 ml-md-n1",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    staticClass: "h-100",
    attrs: {
      "tile": "",
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "pa-16 px-md-30 py-md-20"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "width": "42",
      "height": "42",
      "src": "/images/sub/how-to/how-to-bid-online-icon2.png"
    }
  })], 1), _c('v-col', [_c('div', {
    staticClass: "page-text"
  }, [_c('p', {
    staticClass: "primary--text"
  }, [_vm._v("자동응찰 / Automatic Bid")]), _c('p', [_vm._v("작품의 한도액을 미리 설정해 자동으로 응찰")])]), _c('p', {
    staticClass: "page-text font-size-14 line-height-13 mt-4"
  }, [_vm._v("* 자동응찰의 경우 상대응찰자가 없으면 최소 금액으로 낙찰됩니다.")])])], 1)], 1)])], 1)], 1)], 1)]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("우선 순위")])]), _c('ul', {
    staticClass: "letter-list"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("경매 낙찰은 시작 후 최고가를 제시한 응찰자에게 경매작품이 낙찰되며, 자동응찰 > 수동 응찰 순으로 우선적으로 낙찰 기회가 주어집니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("동일한 금액의 응찰이 발생할 경우 서버시각에 따라 먼저 응찰금액을 입력하신 분에게 우선 순위가 주어집니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("응찰 시 응찰 단위 기준으로 금액이 상승합니다.")])])])]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("호가단위 자동 변경기준")])]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v("다음과 같이 온라인 경매 응찰 금액대별 호가단위가 자동 변경됩니다.")]), _c('div', {
    staticClass: "mt-10 mt-md-14"
  }, [_c('div', {
    staticClass: "table-scroll"
  }, [_c('div', {
    staticClass: "table-scroll__inner"
  }, [_c('v-simple-table', {
    staticClass: "v-simple-table v-data-table--none-active-bg v-data-table--default v-data-table--none-border-left text-center primary--text",
    staticStyle: {
      "min-width": "768px"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("이상")]), _c('td', [_vm._v("~")]), _c('td', [_vm._v("100만원")]), _c('td', [_vm._v("300만원")]), _c('td', [_vm._v("500만원")]), _c('td', [_vm._v("1,000만원")]), _c('td', [_vm._v("3,000만원")]), _c('td', [_vm._v("5,000만원")]), _c('td', [_vm._v("1억원")]), _c('td', [_vm._v("2억원")])]), _c('tr', [_c('th', [_vm._v("미만")]), _c('td', [_vm._v("100만원")]), _c('td', [_vm._v("300만원")]), _c('td', [_vm._v("500만원")]), _c('td', [_vm._v("1,000만원")]), _c('td', [_vm._v("3,000만원")]), _c('td', [_vm._v("5,000만원")]), _c('td', [_vm._v("1억원")]), _c('td', [_vm._v("2억원")]), _c('td', [_vm._v("~")])]), _c('tr', [_c('th', [_vm._v("호가")]), _c('td', [_vm._v("5만원")]), _c('td', [_vm._v("10만원")]), _c('td', [_vm._v("20만원")]), _c('td', [_vm._v("30만원")]), _c('td', [_vm._v("50만원")]), _c('td', [_vm._v("100만원")]), _c('td', [_vm._v("200만원")]), _c('td', [_vm._v("300만원")]), _c('td', [_vm._v("500만원")])])])])], 1)])])]), _c('div', {
    staticClass: "mt-18 mt-md-30"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("온라인경매 예약응찰")])]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v("미리 설정한 최대 응찰금액 까지 자동으로 응찰이 이루어지게 하는 방식입니다.")]), _c('ul', {
    staticClass: "letter-list mt-6 mt-md-10"
  }, [_c('li', [_c('em', [_c('strong', [_vm._v("예)")])]), _c('div', [_c('p', {
    staticClass: "page-text"
  }, [_c('strong', [_vm._v("시작가 1,000,000원 (호가단위 100,000원)")]), _c('br'), _vm._v(" 상기 작품에 대해 2,000,000원 까지 예약응찰 할 경우 다른 응찰자가 1,100,000원 응찰 시"), _c('br'), _vm._v(" 1,200,000원이 자동응찰 되며, 이후 응찰이 더 발생할 경우 입력한 2,000,000원 까지 자동응찰됩니다. ")]), _c('p', {
    staticClass: "page-text mt-6 mt-md-10"
  }, [_c('strong', [_vm._v("설정 금액 보다 낮은 가격에서 경매가 끝난다면?")]), _c('br'), _vm._v(" 설정해둔 최대 응찰가 2,000,000원 과는 상관없이 경합된 금액까지만 낙찰가로 결정됩니다. ")]), _c('p', {
    staticClass: "page-text mt-6 mt-md-10"
  }, [_c('strong', [_vm._v("설정한 금액 보다 높게 응찰이 이어진다면?")]), _c('br'), _vm._v(" 예약한 최대 응찰가를 넘어섰으므로, 직접 응찰을 진행해야 경매참여가 가능합니다. ")])])])]), _c('ul', {
    staticClass: "letter-list mt-6 mt-md-10"
  }, [_c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("일반응찰과 동일금액으로 응찰된 경우 예약응찰이 우선시 됩니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("예약응찰은 경매 당일 오후 3시 까지만 응찰 가능합니다.")])]), _c('li', [_c('em', [_vm._v("-")]), _c('span', [_vm._v("예약응찰 역시 응찰을 취소 할 수 없습니다.신중한 선택 부탁드립니다.")])])])])])], 1)], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }